<template>
  <div>
  <div class="claim-status-div">
    <div v-if="claimStatus">
      <div class="claim-status">
        <div class="claim-status-header">{{ $t(`${pagei18nKey}.title`) }}</div>
        <div class="claim-status-message">
          {{ tryTranslate('message.apiTranslations', this.claimStatus.claimStatusName) }}
        </div>
      </div>

      <!-- Claim chat messages block --> 
      <div class="claim-message">
        <div class="claim-message-header">{{ $t(`${pagei18nKey}.titleMessages`) }}</div>
        <pre class="claim-message-message">
          {{ getLastMessageText() }}
        </pre>
        <div v-if='getLastMessageDocumentId() != null'>
          <a class="link-text" target='_blank' v-bind:href='getLastMessageDocumentUrl()'>{{ getLastMessageDocumentName() }}</a>
        </div>
        <div class="claim-message-footer">
          {{ getLastMessageFooter() }}
        </div>
        <div class="claim-message-buttons">
          <AppButton
              @click.native="openAllMessagesView(guid)"
              class="claim-message-button"
              :state="replacementButtonState"
              :type="replacementButtonType"
              :text="$t(`${pagei18nKey}.viewMessages`)"/>
          <AppButton
              @click.native="openNewMessageModal()"
              class="claim-message-button"
              :state="replacementButtonState"
              :type="replacementButtonType"
              :text="$t(`${pagei18nKey}.newMessage`)"/>
        </div>
      </div>

      <!-- Claim documents block --> 
      <div class="claim-document">
        <div class="claim-document-header">{{ $t(`${pagei18nKey}.titleDocuments`) }}</div>

        <!-- Static image uploads -->
        <ms-file-upload
          ref="documentFileUpload"
          class="image_upload"
          :imageUrl="documentUpload.imageUploadSrc"
          :imageUploadedUrl="documentUpload.imageUploadedSrc"
          :uploadFolder="guid"
          @uploadSuccess="onDocumentUploadSuccess(...arguments)"
          @deleteClick="onDocumentUploadDelete()"/>
          <p>{{document.fileName}}</p>
        <div class="claim-document-buttons">
          <AppButton
            @click.native="sendDocument"
            class="claim-document-button"
            :state="sendDocumentButtonState"
            :type="sendDocumentButtonType"
            :text="$t(`${pagei18nKey}.sendDocument`)"/>
        </div>
      </div>    

      <div v-if="isActionRequired()" class="claim-action-required">
        <div class="action-required-title">{{ $t(`${pagei18nKey}.actionRequiredTitle`) }}</div>
        <div class="action-required-message">{{ $t(`${pagei18nKey}.actionRequiredText`) }}</div>
      </div>

      <!-- <div v-if="isClaimMissingData(claimStatus)" class="claim-missing-information">
        <div class="claim-missing-information_message">
          <p class="claim-missing-information_heading">
            <span class="claim-missing-information_icon">
              <img
                src="@/assets/theme/images/exclamation-icon.png"
                :alt="$t(`${pagei18nKey}.missingDataIconAlt`)">
            </span>
            {{ $t(`${pagei18nKey}.missingDataHeading`) }}
          </p>
          <p>{{ $t(`${pagei18nKey}.missingDataMessage`) }}</p>
          <ul>
            <li v-for="(item, index) in claimStatus.baggageItems" :key="index" class="claim-missing-information-item">
              <div v-if="isItemMissingData(item)" class="claim-missing-information-link">
                <p>
                  <router-link 
                      :to="'/claim-status/update-item/' + guid + '/' + index">
                  {{ getBaggageItemDescription(index) }}
                  </router-link>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div> -->
<!-- 
      <div v-if="claimStatus.addressRequiresConfirmation" class="claim-missing-information">
        <div class="claim-missing-information_message">
          <p class="claim-missing-information_heading">
            <span class="claim-missing-information_icon">
              <img
                src="@/assets/theme/images/exclamation-icon.png"
                :alt="$t(`${pagei18nKey}.missingDataIconAlt`)">
            </span>
            {{ $t(`${pagei18nKey}.addressRequiresConfirmation`) }}
          </p>
          <p class="claim-missing-information_text">
            {{ $t(`${pagei18nKey}.addressRequiresConfirmationMessage`) }}
          </p>
          <AppButton
            @click.native="openAddressConfirmationView(guid)"
            class="process-button"
            :state="replacementButtonState"
            :type="replacementButtonType"
            :text="$t(`${pagei18nKey}.addressRequiresConfirmation`)"/>
        </div>
      </div> -->

      <div v-if="claimStatus.replacementItemsNeedsConfirmation" class="claim-missing-information">
        <div class="claim-missing-information_message">
          <p class="claim-missing-information_heading">
            <span class="claim-missing-information_icon">
              <img
                src="@/assets/theme/images/exclamation-icon.png"
                :alt="$t(`${pagei18nKey}.missingDataIconAlt`)">
            </span>
            {{ $t(`${pagei18nKey}.replacementItemsRequiresConfirmation`) }}
          </p>
          <p class="claim-missing-information_text">
            {{ $t(`${pagei18nKey}.replacementItemsRequiresConfirmationMessage`) }}
          </p>
          <AppButton
            @click.native="openReplacementConfirmationView(guid)"
            class="process-button"
            :state="replacementButtonState"
            :type="replacementButtonType"
            :text="$t(`${pagei18nKey}.replacementItemsRequiresConfirmation`)"/>
        </div>
      </div>

      <div class="claim-status-summary">
        <div class="claim-status-header">{{ $t(`${pagei18nKey}.summaryHeader`) }}</div>
        <div class="claim-status-summary-item">{{ $t(`${pagei18nKey}.claimRef`) }}: {{ claimStatus.claimRef }}</div>
        <div class="claim-status-summary-item">{{ $t(`${pagei18nKey}.claimMade`) }}: {{ formatDate(claimStatus.claimDateCreated) }}</div>
        <div class="claim-status-summary-item">{{ $t(`${pagei18nKey}.flightDate`) }}: {{ formatDate(claimStatus.flightDate) }}</div><br>
        <!-- <div v-if="claimStatus.baggageItems.length > 0" class="claim-status-summary-item">
          {{ $t(`${pagei18nKey}.baggageItems`) }}:
          <ul>
            <li v-for="(item, index) in claimStatus.baggageItems" :key="index">
              {{ getBaggageItemDescription(index) }}
            </li>
          </ul>
        </div> -->
      </div>

      <div class="claim-status-help">
        <div class="claim-status-help-message">
          {{ $t(`${pagei18nKey}.help`) }}
        </div>
        <a href="tel:01279813000" class="claim-status-help_number">
          <span class="claim-status-help_icon">
            <img
              src="@/assets/theme/images/phone-icon.png"
              :alt="$t(`${pagei18nKey}.phoneIconAlt`)">
          </span>
          <span>01279 813000</span>
        </a>
      </div>
    </div>
    <div v-else>
      <div class="loading-div" v-if="loading">
        <img class="spinner" :src="loadingSpinner"/>
      </div>
      <div v-if="loadingError">
        <div class="claim-status-error">
          <div class="claim-status-error-header">{{ $t(`${pagei18nKey}.errorHeader`) }}</div>
          <div class="claim-stauts-error-message">{{ $t(`${pagei18nKey}.errorMessage`) }}</div>
        </div>
      </div>
    </div>
  </div>
  <ms-app-message
    :title="$t(`${pagei18nKey}.newMessageModalTitle`)"
    :isOpen.sync="showSendMessageModal"> 
    <textarea class="textarea has-fixed-size" 
      name="newMessage"
      v-validate="'required|max:' + messageMaxLength"
      :class="{'is-danger': errors.has('newMessage') }"
      data-vv-as="new message"
      v-model="newMesasge"></textarea>
      <p
        v-show="errors.has('newMessage')"
        class="help is-danger">
        {{ errors.first('newMessage') }}
      </p>
    <footer>
      <app-button
        class="claim-message-modal-button"
        :text="$t(yesButton.text)"
        :type="yesButton.type"
        :state="yesButton.state"
        @click.native="sendNewMessage()" />
    </footer>
  </ms-app-message>
  </div>
</template>

<script>
import api from '@/api/api'
import AppSettings from '@/app-settings.json'
import AppButton, {ButtonTypes, ButtonStates} from '@/components/app-button'
import MsFileUpload from '@/components/ms-file-upload'
import { Validator } from 'vee-validate'
import { loadLanguageAsync } from '@/lang'
import MsAppMessage, {defaultModalButtons} from '@/components/ms-app-message'
import { DateTime as LuxonDateTime } from 'luxon'

export default {
  name: 'ClaimStatusView',
  components: {
    AppButton,
    MsAppMessage,
    MsFileUpload
  },
  data: function () {
    return {
      pagei18nKey: 'message.claimStatus',
      claimStatus: null,
      loadingSpinner: AppSettings.submitInProgress,
      loading: false,
      loadingError: false,
      statuses: [],
      types: [],
      brands: [],
      materials: [],
      messages: null,
      messageMaxLength: 1000,
      showSendMessageModal: false,
      newMesasge: '',
      verificationCode: null,
      document: {
        url: null
      },
      documentUpload: {
        imageUploadSrc: '/static/theme/img/upload-document.png',
        imageUploadedSrc: '/static/theme/img/upload-document-success.png'
      }
    }
  },
  props: {
    guid: String
  },
  mounted () {
    this.loading = true

    // see if we have a verifcation code yet?
    this.verificationCode = this.$store.getters.verificationCode
    if (!this.verificationCode) {
      this.$router.push(`/claim-status/verify/${this.guid}`)
      return
    }

    api.getClaimStatus(this.guid, this.verificationCode)
      .then(response => {
        this.claimStatus = response.data
        this.loading = false

        // Add localization
        if (this.claimStatus.claimLanguageIso) {
          Validator.localize(this.claimStatus.claimLanguageIso)

          loadLanguageAsync(this.claimStatus.claimLanguageIso).then(() => {
            /**
             * Get the chat messages for this claim
             */
            api.getClaimMessages(this.guid, this.verificationCode)
              .then(response => {
                // console.log('got claim messages')
                // console.log(response)
                this.messages = response
              })
              .catch(console.error)
            /**
             * Get baggage types data from api
             */
            api.getBaggageTypes()
              .then(response => {
                this.types = response.data
              })
              .catch(console.error)

            /**
             * Get baggage brands data from api
             */
            api.getBaggageBrands()
              .then(response => {
                this.brands = response.data
              })
              .catch(console.error)

            /**
            * Get baggage materials data from api
            */
            api.getBaggageMaterials()
              .then(response => {
                this.materials = response.data
              })
              .catch(console.error)
          })
        }
      })
      .catch(error => {
        console.error(error)
        this.loadingError = true
        this.loading = false
        // check for no auth error
        if (error.response) {
          // TODO update code when server does
          if (error.response.status >= 401 && error.response.status <= 499) {
            // console.log(error.response.status)
            this.$router.push(`/claim-status/verify/${this.guid}`)
          }
        }
      })
  },
  computed: {
    yesButton: {
      get () {
        return Object.assign(
          defaultModalButtons.YES,
          {
            'text': 'message.claimStatus.newMessageModalSendButton'
          }
        )
      }
    },
    replacementButtonState: {
      get () {
        return ButtonStates.ENABLED
      }
    },

    sendDocumentButtonState: {
      get () {
        return this.document.url ? ButtonStates.ENABLED : ButtonStates.DISABLED
      }
    },
    sendDocumentButtonType: {
      get () {
        return ButtonTypes.PRIMARY
      }
    },
    replacementButtonType: {
      get () {
        return ButtonTypes.PRIMARY
      }
    }
  },
  methods: {
    /**
     * i18n doesn't have fallback to plain string option, this function does that instead.
     * Takes path to the translations and tries to translate
     * provided API string. If it doesn't find it, fallbacks to the provided one
     * @param {string} translationPath - e.g 'message.apiTranslations'
     * @param {string} stringToTranslate
     */
    tryTranslate (translationPath, stringToTranslate) {
      let translation = this.$t(`${translationPath}["${stringToTranslate}"]`)

      // In case of unsuccessful translation, translation contains message path
      return translation.includes(translationPath) ? stringToTranslate : translation
    },

    /**
     * Checks if any of the data is missing in the claim
     * @return {boolean}
     */
    isActionRequired () {
      return this.claimStatus.replacementItemsNeedsConfirmation
    },

    /**
     * Remove the file from the document upload
     */
    onDocumentUploadDelete () {
      this.document.url = null
      this.document.fileName = null
    },

    /**
     * on document upload success for individual upload fields
     * push file object into the document urls
     *
     * @param {string} url - Url of uploaded file
     * @param {string} fileName - File name of uploaded file
     */
    onDocumentUploadSuccess (url, fileName) {
      this.document = Object.assign(this.document, { 'url': url, 'fileName': fileName })
    },

    /**
     * Send document file to api
     */
    sendDocument () {
      if (!this.document.url) return
      api.postClaimDocument(this.guid, this.verificationCode, this.document.url, this.document.fileName)
        .then(response => {
          this.onDocumentUploadDelete()
          // clear upload control after submit
          this.$refs.documentFileUpload.onDelete()
          // load messages as recent message shows info about file upload
          this.refreshLatestMessage()
        })
        .catch(console.error)
    },
    /**
     * Iterates claim items and checks if all of them have required data
     * @returns {boolean}
     */
    // isClaimMissingData (claim) {
    //   // If claim is already in repair/replace progress, don't ask for images
    //   if (claim.requireMissingBaggageInformation) {
    //     for (let item of claim.baggageItems) {
    //       if (this.isItemMissingData(item)) {
    //         return true
    //       }
    //     }
    //   }
    //   return false
    // },

    // getBaggageItemDescription (index) {
    //   let baggageItem = this.claimStatus.baggageItems[index]

    //   let baggageBrand = null
    //   if (baggageItem.brand) baggageBrand = this.brands.find(x => x.id === baggageItem.brand.globalId)
    //   let baggageType = null
    //   if (baggageItem.type) baggageType = this.types.find(x => x.id === baggageItem.type.globalId)
    //   let baggageMaterial = null
    //   if (baggageItem.material) baggageMaterial = this.materials.find(x => x.id === baggageItem.material.globalId)

    //   if (baggageBrand && baggageType) {
    //     let brandName = baggageItem.brand.additionalValue || baggageBrand.name
    //     let typeName = baggageItem.type.additionalValue || baggageType.name
    //     let materialName = null
    //     if (baggageItem.material) materialName = baggageItem.material.additionalValue || baggageMaterial.name
    //     // material is optional, brand and type are requuired
    //     if (materialName) return `${brandName} | ${typeName} | ${materialName}`
    //     else return `${brandName} | ${typeName}`
    //   }
    //   return ''
    // },

    /**
     * If baggage item has all the required data
     */
    // isItemMissingData (item) {
    //   if (item.areaOfDamageImages.length < 1 ||
    //      (!item.wholeCaseImage || item.wholeCaseImage.imageUrl == null) ||
    //      (!item.badgeImage || item.badgeImage.imageUrl == null)) {
    //     return true
    //   }
    //   return false
    // },

    openReplacementConfirmationView (guid) {
      if (guid) {
        this.$router.push(`/claim-status/replacement-items/${this.guid}`)
      }
    },

    // openAddressConfirmationView (guid) {
    //   if (guid) {
    //     this.$router.push(`/claim-status/confirm-address/${this.guid}`)
    //   }
    // },

    formatDate (date) {
      let formattedDate = new Date(date).toLocaleDateString()
      return formattedDate
    },

    getLastMessageText () {
      // if not loaded then do nothing
      if (this.messages === null) return '...'
      // if none, the show no message text
      if (this.messages.length <= 0) return this.$t(`${this.pagei18nKey}.noMessages`)
      // if here show last message
      return this.messages[0].text
    },

    getLastMessageDocumentId () {
      if (this.messages == null || this.messages.length <= 0) return null
      console.log('document!')
      console.log(this.messages[0])
      return this.messages[0].documentId
    },

    getLastMessageDocumentName () {
      if (this.messages == null || this.messages.length <= 0) return null
      return this.messages[0].documentName
    },

    getLastMessageDocumentUrl () {
      if (this.messages == null || this.messages.length <= 0) return null
      return this.messages[0].documentUrl
    },

    getLastMessageFooter () {
      if (this.messages == null || this.messages.length <= 0) return ''
      let dateTime = LuxonDateTime.fromISO(this.messages[0].date)
      if (dateTime.isValid) {
        if (this.messages[0].isClient) {
          return this.$t(`${this.pagei18nKey}.messageClientPrefix`) + `, ${dateTime.toFormat('dd LLL yyyy, HH:mm')}`
        } else {
          return this.$t(`${this.pagei18nKey}.messageAdminPrefix`) + `, ${dateTime.toFormat('dd LLL yyyy, HH:mm')}`
        }
      } else {
        console.error('could not parse latest message date')
      }
    },

    openAllMessagesView (guid) {
      if (guid) {
        this.$router.push(`/claim-status/messages/${this.guid}`)
      }
    },

    openNewMessageModal () {
      this.showSendMessageModal = true
    },

    closeNewMessageModal () {
      this.showSendMessageModal = false
    },

    sendNewMessage () {
      // check there is a message to send
      if (!this.newMesasge) return

      this.$validator.validate().then(valid => {
        if (valid) {
          this.closeNewMessageModal()
          this.loading = true
          // todo validate the message before sending
          // todo show error/success message to the user
          // console.log(`post message ${this.verificationCode}`)
          api.postClaimMessage(this.guid, this.verificationCode, this.newMesasge)
            .then(result => {
              // refresh the latest message
              this.refreshLatestMessage()
            })
            .catch(error => {
              this.loading = false
              console.error(error)
            })
        }
      })
    },

    refreshLatestMessage () {
      api.getClaimMessages(this.guid, this.verificationCode)
        .then(response => {
          this.messages = response
        })
        .catch(console.error)
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/sass/main.scss";

.claim-status-div {
  @extend %app_form_container;
}

.claim-status, .claim-status-help, .claim-status-error, .claim-message, .claim-document {
  padding: $dims-padding-default;
  border: 1px solid #dddddd;
  background: $secondary-brand-color;
}

.claim-message, .claim-document {
  margin-top: $dims-padding-default;
}

.claim-message-footer {  
  font-style: italic;
  font-weight: $weight-semibold;
}

.claim-message-message {
  white-space: pre-line; 
  background-color: transparent;
  padding: 0;
  word-wrap: break-word;
  font: inherit;
}

.link-text {
    font-weight: $semibold-font-weight;
    color: $quaternary-text-color;
    cursor: pointer;
}

.claim-status-summary {
  padding: $dims-padding-default 0;
}

.claim-status-header, .claim-status-error-header, .claim-message-header, .claim-document-header {
  font-weight: $weight-bold;
  margin-bottom: $dims-spacing-small;
}

.claim-status-help {
  .claim-status-help-message {
    margin-bottom: $dims-spacing-small;
  }

  .claim-status-help_number {
    color: $primary-brand-color;
    font-weight: $weight-semibold;

    span {
      vertical-align: middle;
    }
  }
}

.claim-action-required {
  margin-top: $dims-padding-default;

  .action-required-title {
    color: $primary-brand-color;
    font-weight: $semibold-font-weight;
  }
}

.claim-missing-information {
  margin-top: $dims-padding-default;
}

.claim-missing-information_heading {
  color: $quaternary-text-color;
  font-weight: $semibold-font-weight;
  display: inline-flex;
  align-items: center;
}

.claim-missing-information-item {
  margin-top: $dims-spacing-small;
}

.claim-missing-information_icon, .claim-status-help_icon {
  width: $find-a-flight-icon-size;
  display: inline-block;
  margin-right: $dims-spacing-small;

  img {
    width: 100%;
    max-width: 100%;
    height: auto;
    display: block;
  }
}

.claim-missing-information {
  margin-top: $dims-padding-default;
}

.claim-missing-information_heading {
  margin-bottom: $dims-spacing-small;
}

.claim-missing-information-link {
  a {
    color: $primary-brand-color;
  }

  &:not(:last-of-type) {
    margin-bottom: $dims-spacing-small;
  }
}

.claim-missing-information_text {
  margin-bottom: $dims-spacing-small;
}

.claim-missing-information_message {
  border: 1px solid $primary-brand-color;
  padding: $dims-padding-default;
}

.action-required-title {
  margin-bottom: $dims-spacing-small;
}

.loading-div {
  position: relative;
  height: 100px;

  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.process-button {
  padding: $dims-spacing-small 0;
}

.claim-message-buttons, .claim-document-buttons {
  padding-top: $dims-spacing-small;
  display: flex;
  justify-content: space-between;
}

.claim-message-button {
  width: 48%;
  padding: $dims-spacing-small 0;
}

.claim-document-button {
  width: 100%;
  padding: $dims-spacing-small 0;
}

.claim-message-modal-button {
  margin-top: $dims-padding-default;
  padding: $dims-spacing-small;
}

</style>
